import { isParticleSystem } from '@ps/utils/game'
import { setAdpaterData } from '@ps/bridge/qc/scripts/vertical-horizontal'
import { getDescendants } from '@ps/bridge/qc/node/utils'

const particle = {
  namespaced: true,

  actions: {
    startParticle(state, node) {
      node = node || state.rootState.workspace.game.activeNode
      node.reset()
      node.pause()
      node.start()
    },
    startAllParticle(state, node) {
      node = node || state.rootState.workspace.game.activeNode
      const nodeChildren = getDescendants(node, false, false)
      nodeChildren.forEach((node) => {
        if (isParticleSystem(node)) {
          node.reset()
          node.pause()
          node.start()
        }
      })
    },
    stopAllParticle(state, node) {
      node = node || state.rootState.workspace.game.activeNode
      const nodeChildren = getDescendants(node, false, false)
      nodeChildren.forEach((node) => {
        if (isParticleSystem(node)) {
          node.reset()
          node.pause()
        }
      })
    },
    pauseParticle(state) {
      state.rootState.workspace.game.activeNode.pause()
    },
    stopParticle(state) {
      state.rootState.workspace.game.activeNode.reset()
      state.rootState.workspace.game.activeNode.pause()
    },

    /**
     * setEndColorVariation
     * @param {{rootState: {}}}
     * @param {{value: string, node: {}}} param1 node:qc.Node
     */
    setEndColorVariation({ rootState, dispatch }, { value, node }) {
      value = Number(value)
      if (node) {
        node.endColorVariation = value
      } else {
        rootState.workspace.game.activeNode.endColorVariation = value
      }

      dispatch('startParticle', node)
    },

    /**
     * setStartColorVariation
     * @param {{rootState: {}}}
     * @param {{value: string, node: {}}} param1 node:qc.Node
     */
    setStartColorVariation({ rootState, dispatch }, { value, node }) {
      value = Number(value)
      if (node) {
        node.startColorVariation = value
      } else {
        rootState.workspace.game.activeNode.startColorVariation = value
      }

      dispatch('startParticle', node)
    },

    /**
     * setDelay
     * @param {{rootState: {}}}
     * @param {{value: string, node: {}}} param1 node:qc.Node
     */
    setDelay({ rootState, dispatch }, { value, node }) {
      value = Number(value)
      if (node) {
        node.delay = value
      } else {
        rootState.workspace.game.activeNode.delay = value
      }
      dispatch('startParticle', node)
    },

    /**
     * setRepeat
     * @param {{rootState: {}}}
     * @param {{value: string, node: {}}} param1 node:qc.Node
     */
    setRepeat({ rootState, state, dispatch }, { value, node }) {
      value = Number(value)
      if (node) {
        node.repeat = value
      } else {
        rootState.workspace.game.activeNode.repeat = value
      }

      dispatch('startParticle', node)
    },

    /**
     * setQuantity
     * @param {{rootState: {}}}
     * @param {{value: string, node: {}}} param1 node:qc.Node
     */
    setQuantity({ rootState, state, dispatch }, { value, node }) {
      value = Number(value)
      if (node) {
        node.quantity = value
      } else {
        rootState.workspace.game.activeNode.quantity = value
      }
      dispatch('startParticle', node)
    },

    /**
     * setFrequency
     * @param {{rootState: {}}}
     * @param {{value: string, node: {}}} param1 node:qc.Node
     */
    setFrequency({ rootState, state, dispatch }, { value, node }) {
      value = Number(value)
      if (node) {
        node.frequency = value
      } else {
        rootState.workspace.game.activeNode.frequency = value
      }
      dispatch('startParticle', node)
    },

    /**
     * setEmissionSpace
     * @param {{rootState: {}}}
     * @param {{value: string, node: {}}} param1 node:qc.Node
     */
    setEmissionSpace({ rootState, state, dispatch }, { value, node }) {
      value = Number(value)
      if (node) {
        node.emissionSpace = value
      } else {
        rootState.workspace.game.activeNode.emissionSpace = value
      }
      dispatch('startParticle', node)
    },

    /**
     * setZoneHeight
     * @param {{rootState: {}}}
     * @param {{value: string, node: {}}} param1 node:qc.Node
     */
    setZoneHeight({ rootState, state, dispatch }, { value, node }) {
      if (node) {
        node.zoneHeight = value
      } else {
        rootState.workspace.game.activeNode.zoneHeight = value
      }
      dispatch('startParticle', node)
    },

    /**
     * setZoneWidth
     * @param {{rootState: {}}}
     * @param {{value: string, node: {}}} param1 node:qc.Node
     */
    setZoneWidth({ rootState, state, dispatch }, { value, node }) {
      if (node) {
        node.zoneWidth = value
      } else {
        rootState.workspace.game.activeNode.zoneWidth = value
      }
      dispatch('startParticle', node)
    },

    /**
     * setEdgeEmission
     * @param {{rootState: {}}}
     * @param {{value: string, node: {}}} param1 node:qc.Node
     */
    setEdgeEmission({ rootState, state, dispatch }, { value, node }) {
      if (node) {
        node.edgeEmission = value
      } else {
        rootState.workspace.game.activeNode.edgeEmission = value
      }
      dispatch('startParticle', node)
    },

    /**
     * setZoneRadius
     * @param {{rootState: {}}}
     * @param {{value: string, node: {}}} param1 node:qc.Node
     */
    setZoneRadius({ rootState, state, dispatch }, { value, node }) {
      value = Number(value)
      if (node) {
        node.zoneRadius = value
      } else {
        rootState.workspace.game.activeNode.zoneRadius = value
      }
      dispatch('startParticle', node)
    },

    /**
     * setZoneRotation
     * @param {{rootState: {}}}
     * @param {{value: string, node: {}}} param1 node:qc.Node
     */
    setZoneRotation({ rootState, state, dispatch }, { value, node }) {
      value = Number(value)
      if (node) {
        node.zoneRotation = value
      } else {
        rootState.workspace.game.activeNode.zoneRotation = value
        state.zoneRotation = value
      }
      dispatch('startParticle', node)
    },

    /**
     * setZoneLength
     * @param {{rootState: {}}}
     * @param {{value: string, node: {}}} param1 node:qc.Node
     */
    setZoneLength({ rootState, state, dispatch }, { value, node }) {
      value = Number(value)
      if (node) {
        node.zoneLength = value
      } else {
        rootState.workspace.game.activeNode.zoneLength = value
      }
      dispatch('startParticle', node)
    },

    /**
     * setZoneType
     * @param {{rootState: {}}}
     * @param {{value: string, node: {}}} param1 node:qc.Node
     */
    setZoneType({ rootState, state, dispatch }, { value, node }) {
      value = Number(value)
      if (node) {
        node.zoneType = value
        rootState.workspace.game.zoneType = value
      } else {
        rootState.workspace.game.activeNode.zoneType = value
      }
      dispatch('startParticle', node)
    },

    /**
     * setGravity
     * @param {{rootState: {}}}
     * @param {{value: string, node: {}}} param1 node:qc.Node
     */
    setGravity({ rootState, state, dispatch }, { value, node }) {
      if (node) {
        node.gravity = value
        rootState.workspace.game.gravityX = value.x
        rootState.workspace.game.gravityY = value.y
      } else {
        rootState.workspace.game.activeNode.gravity = value

        rootState.workspace.game.activeNode.gravityX = value.x
        rootState.workspace.game.activeNode.gravityY = value.y
      }
      dispatch('startParticle', node)
    },

    /**
     * setLifespan
     * @param {{rootState: {}}}
     * @param {{value: string, node: {}}} param1 node:qc.Node
     */
    setLifespan({ rootState, state, dispatch }, { value, node }) {
      value = [Number(value[0] || 0), Number(value[1] || 0)]
      if (node) {
        node.lifespan = value
        node.lifespanMin = value[0]
        node.lifespanMax = value[1]
      } else {
        rootState.workspace.game.activeNode.lifespan = value

        rootState.workspace.game.activeNode.lifespanMin = value[0]
        rootState.workspace.game.activeNode.lifespanMax = value[1]
      }
      dispatch('startParticle', node)
    },

    /**
     * setBlendMode
     * @param {{rootState: {}}}
     * @param {{value: string, node: {}}} param1 node:qc.Node
     */
    setBlendMode({ rootState, dispatch }, { value, node }) {
      value = Number(value)
      if (node) {
        node.blendMode = value
      } else {
        rootState.workspace.game.activeNode.blendMode = value
      }
      dispatch('startParticle', node)
    },

    /**
     * setStartRotation
     * @param {{rootState: {}}}
     * @param {{value: string, node: {}}} param1 node:qc.Node
     */
    setStartRotation({ rootState, state, dispatch }, { value, node }) {
      value = [Number(value[0] || 0), Number(value[1] || 0)]
      if (node) {
        node.startRotation = value
        rootState.workspace.game.startRotationMin = value[0]
        rootState.workspace.game.startRotationMax = value[1]
      } else {
        rootState.workspace.game.activeNode.startRotation = value

        rootState.workspace.game.activeNode.startRotationMin = value[0]
        rootState.workspace.game.activeNode.startRotationMax = value[1]
      }
      dispatch('startParticle', node)
    },

    /**
     * setAngularVelocity
     * @param {{rootState: {}}}
     * @param {{value: string, node: {}}} param1 node:qc.Node
     */
    setAngularVelocity({ rootState, dispatch }, { value, node }) {
      value = [Number(value[0] || 0), Number(value[1] || 0)]
      if (node) {
        node.angularVelocity = value
        rootState.workspace.game.angularVelocityMin = value[0]
        rootState.workspace.game.angularVelocityMax = value[1]
      } else {
        rootState.workspace.game.activeNode.angularVelocity = value

        rootState.workspace.game.activeNode.angularVelocityMin = value[0]
        rootState.workspace.game.activeNode.angularVelocityMax = value[1]
      }
      dispatch('startParticle', node)
    },

    /**
     * setStartAlpha
     * @param {{rootState: {}}}
     * @param {{value: string, node: {}}} param1 node:qc.Node
     */
    setStartAlpha({ rootState, state, dispatch }, { value, node }) {
      value = [Number(value[0] || 0), Number(value[1] || 0)]
      if (node) {
        node.startAlpha = value
        rootState.workspace.game.startAlphaMin = value[0]
        rootState.workspace.game.startAlphaMax = value[1]
      } else {
        rootState.workspace.game.activeNode.startAlpha = value

        rootState.workspace.game.activeNode.startAlphaMin = value[0]
        rootState.workspace.game.activeNode.startAlphaMax = value[1]
      }
      dispatch('startParticle', node)
    },

    /**
     * setStartVelocity
     * @param {{rootState: {}}}
     * @param {{value: string, node: {}}} param1 node:qc.Node
     */
    setStartVelocity({ rootState, state, dispatch }, { value, node }) {
      value = [Number(value[0] || 0), Number(value[1] || 0)]
      if (node) {
        node.startVelocity = value
        rootState.workspace.game.startVelocityMin = value[0]
        rootState.workspace.game.startVelocityMax = value[1]
      } else {
        rootState.workspace.game.activeNode.startVelocity = value

        rootState.workspace.game.activeNode.startVelocityMin = value[0]
        rootState.workspace.game.activeNode.startVelocityMax = value[1]
      }
      dispatch('startParticle', node)
    },

    /**
     * setStartAlpha
     * @param {{rootState: {}}}
     * @param {{value: string, node: {}}} param1 node:qc.Node
     */
    setStartScale({ rootState, state, dispatch }, { value, node }) {
      value = [Number(value[0] || 0), Number(value[1] || 0)]
      const adapterResolution =
        rootState.workspace.game.device.adapterResolution
      if (node) {
        node.startScale = value
        node.startScaleMin = value[0]
        node.startScaleMax = value[1]
        setAdpaterData(node, 'startScale', value, adapterResolution)
        setAdpaterData(node, 'startScaleMin', value[0], adapterResolution)
        setAdpaterData(node, 'startScaleMax', value[1], adapterResolution)
      } else {
        rootState.workspace.game.activeNode.startScale = value

        rootState.workspace.game.activeNode.startScaleMin = value[0]
        rootState.workspace.game.activeNode.startScaleMax = value[1]
        setAdpaterData(
          rootState.workspace.game.activeNode,
          'startScale',
          value,
          adapterResolution,
        )
        setAdpaterData(
          rootState.workspace.game.activeNode,
          'startScaleMin',
          value[0],
          adapterResolution,
        )
        setAdpaterData(
          rootState.workspace.game.activeNode,
          'startScaleMax',
          value[1],
          adapterResolution,
        )
      }
      dispatch('startParticle', node)
    },

    /**
     * setAngle
     * @param {{rootState: {}}}
     * @param {{value: string, node: {}}} param1 node:qc.Node
     */
    setAngle({ rootState, dispatch }, { value, node }) {
      value = [Number(value[0] || 0), Number(value[1] || 0)]
      if (node) {
        node.angle = value
        rootState.workspace.game.angleMin = value[0]
        rootState.workspace.game.angleMax = value[1]
      } else {
        rootState.workspace.game.activeNode.angle = value

        rootState.workspace.game.activeNode.angleMin = value[0]
        rootState.workspace.game.activeNode.angleMax = value[1]
      }
      dispatch('startParticle', node)
    },

    /**
     * setColor
     * @param {{rootState: {}}}
     * @param {{value: string, node: {}}} param1 node:qc.Node
     */
    setStartColor(
      { rootState, dispatch },
      { value, node = rootState.workspace.game.activeNode },
    ) {
      node.startColor = new rootState.workspace.game.data.Color(value)

      dispatch('startParticle', node)
    },

    /**
     * setColor
     * @param {{rootState: {}}}
     * @param {{value: string, node: {}}} param1 node:qc.Node
     */
    setEndColor(
      { rootState, dispatch },
      { value, node = rootState.workspace.game.activeNode },
    ) {
      node.endColor = new rootState.workspace.game.data.Color(value)

      dispatch('startParticle', node)
    },

    /**
     * setPlayOnAwake
     * @param {{rootState: {}}}
     * @param {{value: string, node: {}}} param1 node:qc.Node
     */
    setPlayOnAwake({ rootState, dispatch }, { value, node }) {
      if (node) {
        node.playOnAwake = value
      } else {
        rootState.workspace.game.activeNode.playOnAwake = value
      }

      dispatch('startParticle', node)
    },

    /**
     * setMaxParticles
     * @param {{rootState: {}}}
     * @param {{value: string, node: {}}} param1 node:qc.Node
     */
    setMaxParticles({ rootState, dispatch }, { value, node }) {
      if (node) {
        node.maxParticles = value
      } else {
        rootState.workspace.game.activeNode.maxParticles = value
      }

      dispatch('startParticle', node)
    },

    /**
     * setName
     * @param {{}} state
     * @param {{value: string, node: {}}} param1 node:qc.Node
     */
    setName(
      { rootState },
      { value, node = rootState.workspace.game.activeNode },
    ) {
      node.name = value
    },

    /**
     * setUniqueName
     * @param {{rootState: {}}}
     * @param {{value: string, node: {}}} param1 node:qc.Node
     */
    setUniqueName(
      { rootState },
      { value, node = rootState.workspace.game.activeNode },
    ) {
      node.uniqueName = value
    },
    /**
     * setIgnoreDestroy
     * @param {{rootState: {}}}
     * @param {{value: string, node: {}}} param1 node:qc.Node
     */
    setIgnoreDestroy({ rootState }, { value, node }) {
      if (node) {
        node.ignoreDestroy = false
      } else {
        rootState.workspace.game.activeNode.ignoreDestroy = false
      }
    },
    /**
     * setAlpha
     * @param {{rootState: {}}}
     * @param {{value: string, node: {}}} param1 node:qc.Node
     */
    setAlpha({ rootState }, { value, node }) {
      value = Number(value)
      rootState.workspace.game.activeNode.alpha = Number(value.toFixed(2))
    },
    /**
     * setEnableColorCurve
     * @param {{rootState: {}}}
     * @param {{value: string, node: {}}}
     */
    setEnableColorCurve({ rootState, dispatch }, { value, node }) {
      if (node) {
        node.enableColorCurve = value
      } else {
        rootState.workspace.game.activeNode.enableColorCurve = value
      }
      dispatch('startParticle', node)
    },
    /**
     * setColorCurve
     * @param {{rootState: {}}}
     * @param {{value: string, node: {}}}
     */
    setColorCurve(
      { rootState, dispatch },
      { value, node = rootState.workspace.game.activeNode },
    ) {
      node.colorCurve = value

      dispatch('startParticle', node)
    },
    /**
     * setEnableAlphaCurve
     * @param {{rootState: {}}}
     * @param {{value: string, node: {}}}
     */
    setEnableAlphaCurve({ rootState, dispatch }, { value, node }) {
      if (node) {
        node.enableAlphaCurve = value
      } else {
        rootState.workspace.game.activeNode.enableAlphaCurve = value
      }
      dispatch('startParticle', node)
    },
    /**
     * setAlphaCurve
     * @param {{rootState: {}}}
     * @param {{value: string, node: {}}}
     */
    setAlphaCurve({ rootState, dispatch }, { value, node }) {
      if (node) {
        node.alphaCurve = value
      } else {
        rootState.workspace.game.activeNode.alphaCurve = value
      }
      dispatch('startParticle', node)
    },
    /**
     * setEnableScaleCurve
     * @param {{rootState: {}}}
     * @param {{value: string, node: {}}}
     */
    setEnableScaleCurve({ rootState, dispatch }, { value, node }) {
      if (node) {
        node.enableScaleCurve = value
      } else {
        rootState.workspace.game.activeNode.enableScaleCurve = value
      }
      dispatch('startParticle', node)
    },
    /**
     * setScaleCurve
     * @param {{rootState: {}}}
     * @param {{value: string, node: {}}}
     */
    setScaleCurve({ rootState, dispatch }, { value, node }) {
      if (node) {
        node.scaleCurve = value
      } else {
        rootState.workspace.game.activeNode.scaleCurve = value
      }
      dispatch('startParticle', node)
    },
    /**
     * setEnableVelocityCurve
     * @param {{rootState: {}}}
     * @param {{value: string, node: {}}}
     */
    setEnableVelocityCurve({ rootState, dispatch }, { value, node }) {
      if (node) {
        node.enableVelocityCurve = value
      } else {
        rootState.workspace.game.activeNode.enableVelocityCurve = value
      }
      dispatch('startParticle', node)
    },
    /**
     * setVelocityCurve
     * @param {{rootState: {}}}
     * @param {{value: string, node: {}}}
     */
    setVelocityCurve({ rootState, dispatch }, { value, node }) {
      if (node) {
        node.velocityCurve = value
      } else {
        rootState.workspace.game.activeNode.velocityCurve = value
      }
      dispatch('startParticle', node)
    },
    /**
     * setEnableAngularVelocityCurve
     * @param {{rootState: {}}}
     * @param {{value: string, node: {}}}
     */
    setEnableAngularVelocityCurve({ rootState, dispatch }, { value, node }) {
      if (node) {
        node.enableAngularVelocityCurve = value
      } else {
        rootState.workspace.game.activeNode.enableAngularVelocityCurve = value
      }
      dispatch('startParticle', node)
    },
    /**
     * setAngularVelocityCurve
     * @param {{rootState: {}}}
     * @param {{value: string, node: {}}}
     */
    setAngularVelocityCurve({ rootState, dispatch }, { value, node }) {
      if (node) {
        node.angularVelocityCurve = value
      } else {
        rootState.workspace.game.activeNode.angularVelocityCurve = value
      }
      dispatch('startParticle', node)
    },
  },
}

export default particle
